/* eslint-disable import/prefer-default-export */

export const CAREERS_LINK = 'https://angel.co/company/bizwiseinc/jobs';
export const REFERRAL_APPLICATION_LINK = 'https://reg5ckvdin7.typeform.com/to/Jv4Ssomd';
